getFragmentDoc